import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import styles from '../assets/styles/PasswordReset.module.scss';

const NewPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (!token) {
      alert('トークンが無効です。メールのリンクから再度アクセスしてください。');
      return;
    }
    if (password !== confirmPassword) {
      alert('パスワードが一致しません');
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: token,
          password: password
        }),
      });
      if (res.ok) {
        // 成功時
        alert('パスワードを更新しました。新しいパスワードでログインしてください。');
        navigate('/login');
      } else {
        // 失敗時
        const data = await res.json();
        const errorDetail = data.detail || 'リセットに失敗しました。';
        alert(`${errorDetail}\n有効期限が切れている場合は、再度「パスワードをお忘れの方」から申請してください。`);
      }
    } catch (error) {
      console.error('Reset password error:', error);
      alert('サーバーとの通信に失敗しました。');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.containerWrap}>
      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>

      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.formArea}>
              <img src="/images/logo_aibex_line_b.svg" alt="AI-BEX" className={styles.logo} />

              <h1>パスワードの再設定</h1>

              <form onSubmit={handleSubmit}>
                <label>新しいパスワード <span className={styles.note}>（8文字以上の半角英数字）</span></label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="新しいパスワード"
                  required
                  className={styles.inputTxt}
                  minLength={8}
                />

                <label>新しいパスワード(確認)</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="もう一度入力してください"
                  required
                  className={styles.inputTxt}
                  minLength={8}
                />

                <button
                  type="submit"
                  disabled={isLoading || !token}
                  className={styles.submitBtn}
                >
                  {isLoading ? '処理中...' : 'パスワードを再設定する'}
                </button>
              </form>

              {!token && (
                <p className={styles.errorMessage} style={{ color: '#ff4d4f', marginTop: '1rem', textAlign: 'center' }}>
                  トークンが見つかりません。メールのリンクを正しく開いているかご確認ください。
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;